<template>
  <div id="app" class="app">
    <!-- 全屏显示 -->
    <keep-alive :include="includeList">
      <router-view></router-view>
    </keep-alive>
  </div>
</template>
<script>
import Cookies from 'js-cookie';
import { mapState } from 'vuex';
import apis from '@/utils/apis';
import langs from '@/utils/langs';



export default {
  name: 'App',
  data() {
    return {
      isLoaded: false, // 是否已加载全局多语言
      langComp: {}, // 已加载的组件多语言
      dictionary: {}, // 已加载数据字典
    };
  },
  watch: {
    $route: function () {
      // bug描述： 点击跳转新页面时，el-tooltip如果是显示的话，不会消失
      const els = document.querySelectorAll('.el-tooltip__popper');
      [...els].forEach((el) => {
        el.style.display = 'none';
      });
    },
  },
  computed: {
    ...mapState({
      includeList: state => state.vm.includeList,
    }),
  },
  mounted() {
    // this.zoomHtml();
    const getDictionaryDebounce = this.mergeDebounce(this.getDictionary1);
    const mergeLanguageDebounce = this.mergeDebounce(this.mergeLanguage1);
    const getFuncViewDebounce = this.mergeDebounce(this.getFuncView1);
    this.Bus.$on('getDictionary', getDictionaryDebounce);
    this.Bus.$on('getFuncView', getFuncViewDebounce);
    this.Bus.$on('mergeLanguage', mergeLanguageDebounce);
    this.Bus.$on('asyncLanguage', this.asyncLanguage1);
  },
  methods: {
    // 笔记本适配
    zoomHtml() {
      this.$nextTick(() => {
        var wid = document.body.clientWidth;
        if (wid < 1600) {
          var len = wid / 1800;
          var ele = document.getElementById('html');
          ele.style.zoom = len;
          ele.style['-moz-transform'] = `scale(${len})`;
          ele.style['-moz-transform-origin'] = '0 0';
        }
      });
    },
    // 等待执行
    sleep: async function (time) {
      return new Promise((resolve) => {
        setInterval(() => {
          resolve();
        }, time);
      });
    },
    // 获取指定key新对象
    getFormatData: (data, str) => {
      const keys = str.split(',');
      const todata = {};
      keys.forEach((t) => {
        todata[t] = typeof data[t] === 'undefined' ? null : data[t];
      });
      return todata;
    },
    // 多语言、字典防抖
    mergeDebounce(fn, delay = 200) {
      let timer;
      let argsList;
      return function (...args) {
        if (timer) {
          argsList.push(args);
          clearTimeout(timer);
        } else {
          argsList = [args];
        }
        timer = setTimeout(() => {
          args[args.length] = argsList;
          fn.apply(this, args);
          timer = null;
        }, delay);
      };
    },
    // 获取功能
    getFuncView1(loadRes, cb, argsList) {
      const cache = this.$store.state.funcView;
      if (cache[loadRes]) {
        argsList.forEach((item) => {
          const fn = item[1] || function () {};
          fn(cache[loadRes]);
        });
        return;
      }
      this.$getJSON(apis.FuncView, { loadRes: loadRes }).then((res) => {
        this.$store.commit('FUNCVIEW', Object.assign(cache, { [loadRes]: res.data }));
        argsList.forEach((item) => {
          const fn = item[1] || function () {};
          fn(res.data);
        });
      });
    },

    // 获取字典
    getDictionary1(codes, cb, argsList) {
      const list = argsList
        .map(t => t[0])
        .join(',')
        .split(',');
      const codeList = [...new Set(list)];
      const diffCodes = codeList.filter(t => !Object.keys(this.dictionary).includes(t));
      if (diffCodes.length === 0) {
        argsList.forEach((item) => {
          const params = this.getFormatData(this.dictionary, item[0]);
          const fn = item[1] || function () {};
          fn(params);
        });
        return;
      }
      this.$getJSON(apis.DictionaryCode, {
        groupCodes: diffCodes.join(','),
      }).then((res) => {
        this.dictionary = Object.assign(this.dictionary, res.data || {});
        argsList.forEach((item) => {
          const params = this.getFormatData(this.dictionary, item[0]);
          const fn = item[1] || function () {};
          fn(params);
        });
      });
    },
    // 获取通用多语言
    getCommonLanguage: async function (cb) {
      cb = cb || function () {};
      if (this.isLoaded) {
        cb();
        return;
      }
      const [res1, res2] = await Promise.all([this.$getJSON(apis.LanguagePlatform), this.$getJSON(apis.LanguagePlatform, { appCode: 'customer-portal' })]);
      this.isLoaded = true;
      cb(Object.assign({}, res1.data, res2.data));
      // this.$getJSON(apis.LanguagePlatform).then((res) => {
      //   this.isLoaded = true;
      //   cb(res.data);
      // });
    },
    // 获取组件多语言
    mergeLanguage1: function (code, cb, argsList) {
      const list = argsList
        .map(t => t[0])
        .join(',')
        .split(',');
      const codeList = [...new Set(list)];
      const diffCodes = codeList.filter(t => !Object.keys(this.langComp).includes(t));
      if (diffCodes.length === 0) {
        argsList.forEach((item) => {
          const fn = item[1] || function () {};
          fn();
        });
        return;
      }
      this.getCommonLanguage((commonLang) => {
        this.$getJSON(apis.LanguagePlatformList, {
          keyGroupCode: codeList.join(','),
        }).then((res) => {
          const langCode = Cookies.get('langCode') || 'CN';
          this.$i18n.locale = langCode;
          const messages = this.$i18n.getLocaleMessage(langCode); // 已加载的多语言
          const values = Object.values(res.data || {}).reduce((pre, item) => Object.assign(pre, item), {});
          this.$i18n.setLocaleMessage(langCode, Object.assign({}, messages, values, commonLang || {}));
          argsList.forEach((item) => {
            this.langComp[item[0]] = true; // 记录已加载
            this.$nextTick(() => {
              const fn = item[1] || function () {};
              fn();
            });
          });
        });
      });
    },
    // 同步多语言
    asyncLanguage1: async function () {
      if (process.env.NODE_ENV !== 'development') {
        return;
      }
      const groupCodes = Object.keys(langs);
      // 处理是否删除文件
      const res = await this.$getJSON(apis.LanguageKeyGroupList, { appCode: 'customer-portal' });
      const arr = res.data.map(t => t.langKeyCode).filter(f => !groupCodes.map(k => `portal_${k}`).includes(f));
      console.warn(`service:${res.data.length},local:${groupCodes.length}`);
      arr.forEach((item) => {
        console.warn(`《${item}》组件不存在，请删除相关多语言！`);
      });
      /* eslint-disable */
      console.info('------  多语言同步开始  --------');
      for (let i = 0; i <= groupCodes.length - 1; i++) {
        await this.sleep(300);
        const groupCode = groupCodes[i];
        /* eslint-disable */
        console.info(`《${groupCode}》多语言同步中....`);
        await this.$postJSON(apis.LanguageSyncCompApp, { appCode: 'customer-portal', groupCode: `portal_${groupCode}`, langKey: langs[groupCode] });
        /* eslint-disable */
        console.info(`《${groupCode}》完成`);
        // 处理是否删除多语言项
        const res1 = await this.$getJSON(apis.LanguagePlatformList, { keyGroupCode: `portal_${groupCode}` });
        const obj1 = res1.data[`portal_${groupCode}`];
        const arr1 = Object.keys(obj1).filter((f) => !Object.keys(langs[groupCode]).includes(f));
        arr1.forEach((item) => {
          console.warn(`《${groupCode}》中 ${item} 不存在，请删除！`);
        });
      }
      /* eslint-disable */
      console.info('------  多语言同步结束  --------');
    },
  },
};
</script>

<style lang="scss">
@import './style/base.css';
/*@import "./style/iconfont.css";*/
</style>
